import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tlist-style: decimal outside none;\n\tpadding-left: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0;\n\tmargin-bottom: ", ";\n\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tlist-style: disc outside none;\n\tmargin: 0;\n\tpadding: 0;\n\tpadding-left: ", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var ListView = styled.ul(_templateObject(), ui.space(4));
export var ListItemView = styled.li(_templateObject2(), ui.space(2));
export var ordered = css(_templateObject3(), ui.space(6));